import { z } from "zod";

import { baseHeaderSchema } from "./base-definition";

export const inputSchema = baseHeaderSchema.extend({
  type: z.literal("input"),
  placeholder: z.string().optional(),
  defaultValue: z.string().optional(),
  required: z.boolean().optional().default(false),
});

export type InputType = z.infer<typeof inputSchema>;
